export default __webpack_public_path__ + "static/media/Emanuel-Sparks.07ab6adb.jpg";